import React, { useState, useEffect, useRef } from "react";
import { useLocation, Route, Routes } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../components/Sidebar/Sidebar";
import "../static/css/admin.css";

// Import Views
import PendingOrders from "../views/OMS/pending/pendingorders";
import AllOrders from "../views/OMS/all/allorders";
import ConfirmedOrders from "../views/OMS/confirmed/confirmedorders";
import ConfirmedOrdersList from "../views/OMS/confirmed/confirmedList";
import PackedOrders from "../views/OMS/packed/packedorders";
import ShippedOrders from "../views/OMS/shipped/shippedorders";
import DeliveredOrders from "../views/OMS/delivered/deliveredorders";
import CancelledOrders from "../views/OMS/cancelled/cancelledorders";
import Category from "../views/ProductsCatalogue/Settings/category/category";
import CategoryForm from "../views/ProductsCatalogue/Settings/category/categoryform";
import LogoutAdmin from "../views/LogoutAdmin";
import AllCustomers from "../views/Customer/list";
import Dashboard from "../views/dashboard/Dashboard";
import AllBranches from "../views/Settings/branch";
import ProductsList from "../views/Product/list";
// import Brands from "../views/ProductsCatalogue/Settings/brands/brands";
import AllContacts from "../views/Customer/contact";
import DiscountCreate from "../views/offers/discountCreate";
import Discount from "../views/offers/discount";
import DiscountDetail from "../views/offers/discountDetail";
import AddProduct from "../views/Product/add";
import ProductForm from "../views/Product/ProductForm";
import DeliveryOptionList from "../views/Delivery/deliveryOptionList";
import ItemsList from "../views/Product/itemsList";
import AllEmployees from "../views/employee/employee";
import SaleOrders from "../views/Reports/saleOrder";
import MenuList from "../views/Settings/MenuList";
import QrCampaigns from "../views/Settings/QrCampaigns";
import AllRoles from "../views/Settings/RoleList";
import AllUsers from "../views/Settings/AdminUser";
import SectionList from "../views/sections/SectionList";
import MobileSectionList from "../views/sections/mobile/MobileSectionList";
import DeliveryPerformance from "../views/Reports/DeliveryPerformance";
import DeliveryExecutivePerformance from "../views/Reports/DeliveryExecutivePerformance";
import AllBrands from "../views/ProductsCatalogue/Settings/brands/AllBrands";
import AllCategories from "../views/ProductsCatalogue/Settings/categories/AllCategories";
import SalesProductReport from "../views/Reports/SalesProductReport";
import SupplierEnquiries from "../views/infosite/SupplierEnquiries";
import CareerEnquiries from "../views/infosite/CareerEnquiries";
import DeliverySlotList from "../views/Delivery/DeliverySlotList";
import DeliveryConfiguration from "../views/Delivery/DeliveryConfiguration";
import OrderTransferForm from "../views/OMS/OrderTransferForm";
import OrderStatusUpdateForm from "../views/OMS/OrderStatusUpdateForm";
import OrderHistoryPage from "../views/OMS/OrderHistoryPage";
import DeliveredOrderTimeline from "../views/Reports/DeliveredOrderTimeline";
import PosProductBulkUpload from "../views/Product/PosProductBulkUpload";
import PosProductRefSync from "../views/Product/PosProductRefSync";
import RecipesList from "../views/Product/RecipesList";
import RecipeForm from "../views/Product/RecipeForm";
import ItemSyncCheckPage from "../views/SyncAudit/ItemSyncCheckPage";
import SyncRunsList from "../views/SyncAudit/SyncRunsList";
import SyncRunDetail from "../views/SyncAudit/SyncRunDetail";
import UnmatchedItems from "../views/SyncAudit/UnmatchedItems";
import BranchZones from "../views/Settings/branchZones";
import ThemeManager from "../views/sections/themes/ThemeManager";
import RefundCreatePage from "../views/Payments/RefundCreatePage";
import RefundListPage from "../views/Payments/RefundListPage";
import OnlineOrdersReport from "../views/Reports/OnlineOrdersReport";
import DeliveryAppSettingsList from "../views/DeliveryApp/DeliveryAppSettingsList";
import DeliveryAppCancelReasonsList from "../views/DeliveryApp/DeliveryAppCancelReasonsList";
import ShippingChargeItemMappingsList from "../views/Settings/ShippingChargeItemMappingsList";
import OfferManualForm from "../views/offers/OfferManualForm";
import BogoList from "../views/offers/BogoList";
import ProductItemEanList from "../views/Product/ProductItemEanList";
import ProductItemEanBulkUpload from "../views/Product/ProductItemEanBulkUpload";
import BranchZonesOverview from "../views/Settings/BranchZonesOverview";
import ZonePointLocator from "../views/Settings/ZonePointLocator";
import OrderLocationPage from "../views/OMS/OrderLocationPage";
import PickerPackerSummaryReport from "../views/Reports/PickerPackerSummaryReport";
import PickerPackerItemChangesReport from "../views/Reports/PickerPackerItemChangesReport";
import PickerPackerOrderTimeReport from "../views/Reports/PickerPackerOrderTimeReport";
import BusinessPerformanceReport from "../views/Reports/BusinessPerformanceReport";
import CustomerAddressList from "../views/Customer/CustomerAddressList";
import CustomerAddressLocationPage from "../views/Customer/CustomerAddressLocationPage";
import OutOfZoneCustomerAddresses from "../views/Customer/OutOfZoneCustomerAddresses";
import SalesReport from "../views/Reports/SalesProductReport";
import ExpressOrderDelayReport from "../views/Reports/ExpressDelayReport";
import OrderProcessingTimeReport from "../views/Reports/OrderProcessingTimeReport";
import CustomerEngagementReport, { NonOrderedCustomersReport } from "../views/Reports/CustomerEngagementReport";
import AbandonedCartsReport from "../views/Reports/AbandonedCartsReport";
import PickingExceptionsReport from "../views/Reports/PickingExceptionsReport";
import WeatherRainAlerts from "../views/Settings/WeatherRainAlerts";
import IntegrationManagement from "../views/Settings/IntegrationManagement";
import OfflineSyncMonitor from "../views/SyncAudit/OfflineSyncMonitor";
import EliteHandoffs from "../views/Settings/EliteHandoffs";
import ProductGroups from "../views/ProductsCatalogue/Settings/productgroup/productgroup";

import UnitSettings from '../views/ProductsCatalogue/Settings/unitsettings/unitsetting';
function Admin() {
  const location = useLocation();
  const mainPanel = useRef(null);

  const accessData = JSON.parse(localStorage.getItem("accessData")) || { menu: [] };
  const menuList = accessData.menu;
  // console.log(menuList, 'menuList');
  const MobileSectionHome = () => <MobileSectionList type="home" />;
  const MobileSectionOffer = () => <MobileSectionList type="offer" />;
  // Map routes to components
  const routerComponent = {
    dashboard: Dashboard,
    oms: PendingOrders,
    omsall: AllOrders,
    omspending: PendingOrders,
    omsconfirmed: ConfirmedOrders,
    omspacked: PackedOrders,
    omsshipped: ShippedOrders,
    "omsconfirm-delivery": ConfirmedOrdersList,
    omsdelivered: DeliveredOrders,
    omscancelled: CancelledOrders,
    "omstransfer-order": OrderTransferForm,
    "omstransfer-status": OrderStatusUpdateForm,
    customersall: AllCustomers,
    "supportcontact-message": AllContacts,
    categories: Category,
    employees: Category,
    reports: Category,
    "store-settingsbranches": AllBranches,
    "product-managementproducts": ProductsList,
    "product-managementprice-stock-update": ItemsList,
    "product-managementbrand": AllBrands,
    "product-managementcategories": AllCategories,
    "products-add": AddProduct,
    "products-addnew": ProductForm,
    "products-addbulk": PosProductBulkUpload,
    "products-addpos": PosProductRefSync,
    "product-managementrecipes": RecipesList,
    "recipes-add": RecipeForm,
    "categories-add": CategoryForm,
    "offersdiscount-create": DiscountCreate,
    "offersdiscount": Discount,
    "offersdetail": DiscountDetail,
    "store-settingsdelivery-timings": DeliverySlotList,
    "store-settingsdelivery-options": DeliveryOptionList,
    "store-settingsdelivery-configuration": DeliveryConfiguration,
    employeesall: AllEmployees,
    'reportssale-orders': SaleOrders,
    'reportsorder-timeline': DeliveredOrderTimeline,
    'admin-settingsmenus': MenuList,
    'admin-settingsroles': AllRoles,
    'admin-settingsadmin-users': AllUsers,
    'designsweb-page': SectionList,
    'designsqr-campaigns': QrCampaigns,
    'designsmobile-home': MobileSectionHome,
    'designsmobile-offer': MobileSectionOffer,
    'reportsdelivery-performance': DeliveryPerformance,
    'reportsdelivery-executive-performance': DeliveryExecutivePerformance,
    'reportsproduct-sales': SalesProductReport,
    'info-sitesupplier-enquires': SupplierEnquiries,
    'info-sitecareer-enquires': CareerEnquiries,
    'orderhistory': OrderHistoryPage,
    'reportsgofrugal-sync': SyncRunsList,
    'reportsgofrugal-item-check': ItemSyncCheckPage,
    'reportsgofrugal-sync-detail': SyncRunDetail,
    'reportsgofrugal-detail-unmatched': UnmatchedItems,
    "branch-zones": BranchZones,
    'designs-themes': ThemeManager,
    'payments-refunds-create': RefundCreatePage,
    'omsorder-refunds': RefundListPage,
    'reportsonline-paid-orders': OnlineOrdersReport,
    "logistic-delivery-appdelivery-app-settings": DeliveryAppSettingsList,
    "logistic-delivery-appapp-cancel-reasons": DeliveryAppCancelReasonsList,
    "store-settingsshipping-charge-mapping": ShippingChargeItemMappingsList,
    "offersmanual-create": OfferManualForm,
    "offersmanual-edit": OfferManualForm,
    "offersbogo": BogoList,
    "product-managementitem-ean-codes": ProductItemEanList,
    "product-managementitem-ean-bulk-upload": ProductItemEanBulkUpload,
    "product-managementproduct-groups": ProductGroups,
    "product-managementunits": UnitSettings,
    "store-settingsbranch-zone-overview": BranchZonesOverview,
    "store-settingszone-point-locator": ZonePointLocator,
    "branch-zones-overview": BranchZonesOverview,
    "branch-zone-point-locator": ZonePointLocator,
    "order-location-page": OrderLocationPage,

    "customer-address-list": CustomerAddressList,
    "customer-address-location": CustomerAddressLocationPage,
    "customersout-of-zone-addresses": OutOfZoneCustomerAddresses,

    // "reportspicker-packer-activity": PickerPackerActivityReport,
    "reportspicker-packer-activity": PickerPackerSummaryReport,
    "reportspicker-packer-item-changes": PickerPackerItemChangesReport,
    "reportspicker-packer-order-time": PickerPackerOrderTimeReport,
    "reportsbusiness-performance": BusinessPerformanceReport,


    "reportssales-report": SalesReport,
    "reportsexpress-order-delay": ExpressOrderDelayReport,
    "reportsorder-processing-time": OrderProcessingTimeReport,
    "reportsnewly-registered-customers": CustomerEngagementReport,
    "reportscustomers-without-orders": NonOrderedCustomersReport,
    "reportsabandoned-carts": AbandonedCartsReport,
    "reportspicking-exceptions": PickingExceptionsReport,
    "store-settingsweather-rain-alerts": WeatherRainAlerts,
    "admin-settingsintegration-management": IntegrationManagement,
    
  };

  const extraMenuList = [
    { uri: "/designs/qr-codes", title: "designsqr-campaigns" },
    { uri: "/reports/new-customers", title: "reportsnewly-registered-customers" },
    { uri: "/reports/non-ordered-customers", title: "reportscustomers-without-orders" },
    { uri: "/reports/abandoned-carts", title: "reportsabandoned-carts" },
    { uri: "/recipes/add", title: "recipes-add" },
    { uri: "/products/add", title: "products-add" },
    { uri: "/products/addnew", title: "products-addnew" },
    { uri: "/products/addbulk", title: "products-addbulk" },
    { uri: "/products/addpos", title: "products-addpos" },
    { uri: "/category/add", title: "categories-add" },
    { uri: "/offers/discount/create", title: "offersdiscount-create" },
    // { uri: "/reports/sale/products", title: "reportssale-products" },
    { uri: "/orders/:orderId/history", title: "orderhistory" },
    { uri: "/gofrugal-sync/item-check", title: "reportsgofrugal-item-check" },
    { uri: "/gofrugal-sync", title: "reportsgofrugal-sync" },
    { uri: "/gofrugal-sync/:runId", title: "reportsgofrugal-sync-detail" },
    { uri: "/gofrugal-sync/unmatched", title: "reportsgofrugal-detail-unmatched" },
    { uri: "/branch/:branchId/zones", title: "branch-zones" },
    { uri: "/designs/themes", title: "designs-themes" },
    { uri: "/payments/refunds/create", title: "payments-refunds-create" },
    { uri: "/payments/refunds", title: "payments-refunds-list" },
    // { uri: "/store-settings/delivery-app-settings", title: "store-settingsdelivery-app-settings" },
    // { uri: "/store-settings/delivery-app-cancel-reasons", title: "store-settingsdelivery-app-cancel-reasons" },
    { uri: "/store-settings/shipping-charge-mapping", title: "store-settingsshipping-charge-item-mapping" },
    { uri: "/store-settings/delivery-configuration", title: "store-settingsdelivery-configuration" },
    { uri: "/offers/manual/create", title: "offersmanual-create" },
    { uri: "/offers/manual/edit/:id", title: "offersmanual-edit" },
    { uri: "/offers/bogo", title: "offersbogo" },
    { uri: "/products/item-ean-bulk-upload", title: "product-managementitem-ean-bulk-upload" },
    { uri: "/branch/zones/overview", title: "branch-zones-overview" },
    { uri: "/branch/zones/locator", title: "branch-zone-point-locator" },
    { uri: "/orders/location/:orderId", title: "order-location-page" },
    { uri: "/customers/:customerId/addresses", title: "customer-address-list" },
    { uri: "/customers/address/:addressId/location", title: "customer-address-location" },
    { uri: "/customers/out-of-zone-addresses", title: "customersout-of-zone-addresses" },
    { uri: "/reports/picker-packer-activity", title: "reportspicker-packer-activity" },
    { uri: "/reports/picker-packer-item-changes", title: "reportspicker-packer-item-changes" },
    { uri: "/reports/picker-packer-order-time", title: "reportspicker-packer-order-time" },
    { uri: "/reports/business-performance", title: "reportsbusiness-performance" },
    { uri: "/store-settings/weather-rain-alerts", title: "store-settingsweather-rain-alerts" },
    { uri: "/settings/integrations", title: "admin-settingsintegration-management" },
  ];

  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const generateRoutes = (routes, parentLayout = "/admin", parentMenuName = "") => {
    return routes.map((route, key) => {
      // console.log(route.child);
      const fullPath = parentLayout + (route.uri || "");
      const compName = slugify(parentMenuName + route.title);
      // console.log(compName, 'Menu ID');
      const DynamicComponent = routerComponent[compName] || null;

      // console.log("DynamicComponent", fullPath);
      let childMenuLength = route.child && route.child.length ? route.child.length : 0;

      // Handle dynamic routes like /offers/details/:id
      if (DynamicComponent && childMenuLength === 0) {
        return <Route path={fullPath} element={<DynamicComponent />} key={key} />;
      }
      // Handle nested routes
      if (childMenuLength > 0) {

        return generateRoutes(route.child, route.layout || parentLayout, compName);
      }

      return null;
    });
  };


  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainPanel.current) mainPanel.current.scrollTop = 0;

    if (window.innerWidth < 993 && document.documentElement.classList.contains("nav-open")) {
      document.documentElement.classList.toggle("nav-open");
      const element = document.getElementById("bodyClick");
      if (element) element.parentNode.removeChild(element);
    }
  }, [location]);

  const [mdColSpan, setMdColSpan] = useState({ sidebar: 2, mainContent: 10 });

  const changeContainerWidth = (sideBarStatus) => {
    // console.log(sideBarStatus,'sideBarStatus');
    setMdColSpan(sideBarStatus ? { sidebar: 12, mainContent: 12 } : { sidebar: 2, mainContent: 10 });
  };

  return (
    <Container fluid className="vh-100 d-flex p-0">
      <div className="content-container flex-grow-1 overflow-hidden">
        <div ref={mainPanel} className="h-100 d-flex flex-column">
          <div className="content overflow-auto">
            <Sidebar menuList={menuList} change={changeContainerWidth} />
            <Container fluid className="px-3">
              <Row>
                <Col md={mdColSpan.sidebar}></Col>
                <Col md={mdColSpan.mainContent}>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/admin/" element={<Dashboard />} />
                    {generateRoutes(menuList)}
                    {generateRoutes(extraMenuList)}
                    <Route path="/offers/details/:id" element={<DiscountDetail />} />
                    <Route path="/admin/gofrugal-offline" element={<OfflineSyncMonitor />} />
                    <Route path="/admin/settings/elite-handoffs" element={<EliteHandoffs />} />
                    <Route path="/admin/logout" element={<LogoutAdmin />} />
                  </Routes>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default Admin;


